export default __webpack_public_path__ + "static/media/hht1_ep5_minisitcom_04.9671ba17.png";